"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _TermSelector = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/TermSelector"));

var _ItemConfigsSelectors = require("pricing-pages-unified-ui/selectors/ItemConfigsSelectors");

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _MerchandiseIdsToUpgradeProducts = require("self-service-api/constants/MerchandiseIdsToUpgradeProducts");

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var CalcTermSelectorContainer = function CalcTermSelectorContainer(_ref) {
  var activeTerm = _ref.activeTerm,
      merchandiseId = _ref.merchandiseId,
      onChange = _ref.onChange,
      availableTerms = _ref.availableTerms,
      annualDiscount = _ref.annualDiscount,
      activeCurrencyCode = _ref.activeCurrencyCode;
  var hasTwoAvailableTerms = availableTerms.monthly && availableTerms.annual;
  var upgradeProduct = _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[merchandiseId];
  return _react.default.createElement("div", null, _react.default.createElement(_TermSelector.default, {
    readOnly: !hasTwoAvailableTerms,
    activeTerm: activeTerm,
    onChange: onChange,
    trackingSource: _Tracking.CALCULATOR + "-" + upgradeProduct,
    annualDiscountPercent: annualDiscount,
    activeCurrencyCode: activeCurrencyCode
  }));
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId;
  return {
    availableTerms: (0, _ItemConfigsSelectors.availableTermsForMerchSelector)(state, merchandiseId),
    annualDiscount: (0, _PromotionSelectors.annualDiscountSelector)(state, merchandiseId),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(CalcTermSelectorContainer);

exports.default = _default;
module.exports = exports.default;